import React from "react";
import { styled, Stack, Typography, Card, CardProps } from "@mui/material";
import TitleItem from "../../Lists/TitleItemList/TitleItem";

export type TitleCardProps = {
  poster: string;
  title: string;
  subtitle?: string;
  price?: string;
  titleId: number;
} & CardProps;

const TitleCard: React.FC<TitleCardProps> = (props) => {
  const { title, subtitle, poster, price, titleId, ...otherProps } = props;

  return (
    <StyledCard variant="outlined" {...otherProps}>
      <TitleItem
        poster={poster}
        posterProps={{ width: 32, height: 46 }}
        title={title}
        titleId={titleId}
        desc={subtitle}
        rightContent={
          <Stack flex={1} alignItems="flex-end" pr={1} minWidth={65}>
            {price && (
              <Typography variant="subtitle2" fontWeight={400} color="text.tier">
                {price}
              </Typography>
            )}
          </Stack>
        }
      />
    </StyledCard>
  );
};

const StyledCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(1),
}));

export default TitleCard;
